<script lang="ts" setup>
const props = withDefaults(defineProps<{ placeholder?: string, size?: string, searchCollection?: string, searchClass?: string }>(), { pending: false, placeholder: 'What are you looking for?', size: 'xl' })
const emit = defineEmits(['focus'])

const query = defineModel<string>('query')
const throttledQuery = ref('')
onMounted(() => {
  throttledQuery.value = query.value ?? ''
})
interface CategoryResults {
  type: string
  results: any[]
  totalItems: number
}
const searchCategories = ['pages', 'businesses', 'categories', 'news', 'events', 'offers']

const fullFilters = ref<any[]>([])
fullFilters.value = searchCategories.map((category, index) => {
  return { name: category, active: false, toggle: () => toggleFilter(index) }
})

const filters = computed(() => fullFilters.value?.filter((f: any) => f.active).map((f: any) => f.name) ?? [])
const pb = useNuxtApp().$pb
const data = ref<{ results: CategoryResults[], totalItems: number } | null>(null)
const status = ref<'idle' | 'pending' | 'success' | 'error'>('idle')
// const { data, status, refresh } = useFetch<{ results: CategoryResults[], totalItems: number }>('main-search', async () => {
//   return await pb.send(`/search/${throttledQuery.value}`, computedQuery.value)
// }, { watch: [query, filters], server: false, immediate: false })

async function fetchSearch() {
  if (!query.value) {
    data.value = null
    status.value = 'idle'
    return
  }
  status.value = 'pending'
  try {
    const res = await pb.send(`/search/${throttledQuery.value}`, computedQuery.value)
    data.value = res
    status.value = 'success'
  }
  catch (error) {
    status.value = 'error'
  }
}
const computedQuery = computed(() => {
  const query: any = {}
  if (props.searchCollection) {
    query.collection = props.searchCollection
  }
  else if (filters.value.length) {
    query.collection = filters.value.join(',')
  }
  return query
})

watch([throttledQuery, computedQuery], ([newthrottledQuery, newcomputedQuery], [prevthrottledQuery, prevcomputedQuery]) => {
  fetchSearch()
}, { immediate: true, deep: true })

watchThrottled(
  query,
  (val) => {
    throttledQuery.value = val
  },
  { throttle: 1500 },
)

const displaySearchResults = computed(() => query.value && (status.value === 'pending' || status.value === 'success'))

function toggleFilter(index: number) {
  fullFilters.value[index].active = !fullFilters.value[index].active
}

const router = useRouter()

function goToSearch() {
  router.push({ path: '/search', query: { q: query.value } })
}

defineShortcuts({
  enter: {
    usingInput: 'searchQuery',
    handler: () => {
      goToSearch()
    },
  },
})
</script>

<template>
  <div>
    <div
      class="max-w-4xl mx-auto flex"
      :class="searchClass"
    >
      <div class="p-1 bg-white rounded-full w-full flex-1 flex gap-3 shadow-xl">
        <UInput
          v-model="query"
          :placeholder="placeholder"
          class="w-full lg:flex-1"
          name="searchQuery"
          autocomplete="off"
          :size="size"
          :ui="{ icon: { trailing: { pointer: '' } }, placeholder: 'placeholder-primary-700 font-bold', base: '!ring-transparent hover:!ring-primary-800 focus:!ring-primary inline-flex items-center !px-3 md:!px-4 xl:!px-6' }"
          @focus="emit('focus')"
        >
          <template #trailing>
            <UButton
              v-show="query !== ''"
              icon="ri:close-line"
              aria-label="Clear Search"
              color="gray"
              variant="ghost"
              size="xs"
              class="z-40 relative hover:text-red-500"
              @click="query = ''"
            />
          </template>
        </UInput>
        <slot :go-to-search="goToSearch" />
      </div>
    </div>
    <slot
      name="results"
      :query="query"
      :results="data?.results"
      :total-items="data?.totalItems ?? 0"
      :visible="displaySearchResults"
      :status="status"
      :filters="fullFilters"
      :filters-active="filters.length"
    />
  </div>
</template>
